import React from 'react';
import AdminLayout from '../../../Components/CommonComponents/Layout/adminLayout';
import CompaniesContainer from '../../../Containers/AdminContainer/Companies';

const CompaniesScreen = () => {
  return <CompaniesContainer />;
};

export default CompaniesScreen;
